// extracted by mini-css-extract-plugin
module.exports = {"lds-roller":"style_lds-roller__1mL_u","div-after":"style_div-after__1Xi4B"};